import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * PUT `/crm/sales-order/{id}/sn-selections`。僅 DRAFT；完整替換。
 * body：`updatedAt`、`selections[{ salesOrderLineMtrId, mtrSnIds[] }]`。不占用 SN（送審才占用）。
 */
export async function updateSalesOrderSnSelections(id, payload) {
  const { data: raw } = await request.put(
    `/crm/sales-order/${id}/sn-selections`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
